module.exports = __webpack_public_path__ + "static/media/CocoPi.57b71bed.png";